import { useAuth } from '../../context/AuthContext';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { deriveNameFromEmail } from '../../utils/nameFromEmail';

const headerStyle = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600&display=swap');
  .hh-header { background:white; border-bottom:1px solid #e8ebf4; padding:12px 24px; display:flex; align-items:center; justify-content:space-between; position:sticky; top:0; z-index:30; font-family:'Sora',sans-serif; }
  .hh-avatar { width:34px; height:34px; border-radius:10px; background:#fdf2f8; color:#ec4899; display:flex; align-items:center; justify-content:center; font-size:.72rem; font-weight:700; flex-shrink:0; }
  .hh-name { font-size:.8rem; font-weight:600; color:#1a1d2e; }
  .hh-logout { padding:7px 14px; background:#fdf2f8; color:#ec4899; border:1px solid #fbcfe8; border-radius:9px; font-size:.78rem; font-weight:600; font-family:'Sora',sans-serif; cursor:pointer; transition:background .15s; }
  .hh-logout:hover { background:#fce7f3; }
  .hh-menu-btn { display:none; background:none; border:none; cursor:pointer; padding:4px; }
  @media(max-width:768px) {
    .hh-menu-btn { display:flex; }
    .hh-name { display:none; }
    .hh-logout { padding:6px 10px; font-size:.72rem; }
  }
`;

const HostelHeader = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const displayName = user?.name || deriveNameFromEmail(user?.email) || 'Hostel Member';
  const initials = (n='') => n.split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase() || '?';
  return (
    <>
      <style>{headerStyle}</style>
      <header className="hh-header">
        <button onClick={onMenuClick} className="hh-menu-btn">
          <Bars3Icon style={{ width:22, height:22, stroke:'#6b7194' }} />
        </button>
        <div style={{ fontSize:'.9rem', fontWeight:700, color:'#0f1123' }}>Hostel Portal</div>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <div className="hh-avatar">{initials(displayName)}</div>
          <div className="hh-name">{displayName}</div>
          <button className="hh-logout" onClick={logout}>Logout</button>
        </div>
      </header>
    </>
  );
};

export default HostelHeader;
